export default "__VITE_ASSET__D5h4dh0j__"